"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var ProgramGuide_1 = __importDefault(require("../../components/ProgramGuide"));
if (document.querySelector('.program-guide-wrapper')) {
    ProgramGuide_1.default.getInstance();
}
